var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","name":"button"},on:{"click":_vm.endOF}},[_c('i',{staticClass:"far fa-check-square"}),_vm._v(" Terminer of "+_vm._s(_vm.ofid))])])}
var staticRenderFns = []

export { render, staticRenderFns }